import { render, staticRenderFns } from "./OpenPermissionRequests.vue?vue&type=template&id=4a16864c&scoped=true"
import script from "./OpenPermissionRequests.vue?vue&type=script&lang=js"
export * from "./OpenPermissionRequests.vue?vue&type=script&lang=js"
import style0 from "./OpenPermissionRequests.vue?vue&type=style&index=0&id=4a16864c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a16864c",
  null
  
)

export default component.exports